export default class DesignFeaturesViewModel {
	pedestrians: string | null = null;
	pedalCyclists: string | null = null;
	publicTransport: string | null = null;
	walkingConnectivityScore: number | null = null;
	cyclingConnectivityScore: number | null = null;
	publicTransportConnectivityScore: number | null = null;
}
